"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONGUpToken = exports.ONGWrappedToken = exports.ONGNativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.ONGNativeToken = new utils_1.Currency("ONG", 18, "ONG", "ONG");
exports.ONGWrappedToken = new utils_1.Currency("0xbAC439C9092258710239971Cf883a435F214c3E3", 18, "WONG", "Wrapped ONG");
exports.ONGUpToken = new utils_1.Currency("0xA358573C3CebE7e7F9903e06d966c0Fb8D2aeA1C", 18, "UP", "UP");
